import { url } from '@/helpers/UrlHelpers';
import ApiEndpoints from '@/config/ApiEndpoints';
import ApiService from '@/services/ApiService';

export default class UpdateOrder {
    apiService

    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);
        this.apiService.enableAuth();
    }

    handle(subscriptionId, products) {
        let apiUrl = url(ApiEndpoints['shop.order.update'], [subscriptionId]);

        return this.apiService.post(apiUrl, products);
    }
}
